import { Toaster_ENUM } from 'components/constants/dsmConstants'
import { getUserLanguage, restrictInput } from '../../../helpers/Helper'
import { HelperConstant } from '../../../helpers/HelperConstant'
import { CustomButton } from 'components/shared/CustomButton'
import { CustomDropdown } from 'components/shared/CustomDropdown'
import { CustomNumberOnlyBox } from 'components/shared/CustomNumberOnlyBox'
import { CustomPhoneNumberBox } from 'components/shared/CustomPhoneNumberBox'
import { CustomTextBox } from 'components/shared/CustomTextBox'
import { CustomToaster } from 'components/shared/CustomToaster'
import { useFormik } from 'formik'
import { IAddressModel } from 'models/Address.Model'
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model'
import React, { useEffect, useState } from 'react'
import { Row, Col, Form } from 'reactstrap'
import CommonService from 'services/CommonService'
import UserAddressServices from 'services/UserAddress.Services'
import unique from 'underscore'
import * as Yup from "yup";

type AddressAEProps = {
    setIsAdd: any,
    personDetailInfo: Array<IAddressModel>,
    isEdit: boolean,
    defaultValues?: any
    publicUserUniques: { Id: number, UserName: string, UserMobile: any },
    personId: any
}

export default function AddressFormAE({ setIsAdd, personDetailInfo, isEdit, defaultValues, publicUserUniques, personId }: AddressAEProps) {

    const [isDefault, setIsDefault] = useState<boolean>(false);
    const [dofyGeoList, setDofyGeoList] = useState<Array<any>>([]);
    const [addressType, setAddressType] = useState<Array<any>>([]);
    const [pinLocationErr, setPinLocationErr] = useState(true);
    const [cityList, setCityList] = useState<Array<any>>([]);
    const [Village, setVillage] = useState<Array<any>>([]);
    const [selectedLocationId, setSelectedLocationId] = useState<number>(0);
    const [filterLocation, setFilterLocationList] = useState<Array<any>>([]);
    const [toast, setToast] = useState(false);
    const [stateList, setStateList] = useState<Array<any>>([]);

    // let personDetailsFromPendingOrder = JSON.parse(localStorage.getItem("PendingOrders")!) as Array<IGetOrderSummaryModel>;
    // const customerInfo = personDetailsFromPendingOrder.filter(x => x.UserName === publicUserUniques.UserName);

    const formik = useFormik<IAddressModel>({
        enableReinitialize: true,
        initialValues: {
            Id: 0,
            PersonId: 0,
            CountryId: 0,
            StateId: 0,
            CityId: 0,
            PinCode: '',
            Address: '',
            Address1: '',
            LandMark: '',
            Name: publicUserUniques.UserName,
            MobilePhone: publicUserUniques.UserMobile,
            WorkPhone: '',
            HomePhone: '',
            EmailId: '',
            AddressTypeId: 0,
            IsDefault: false,
            LocationPin: '',
            ApartmentNumber: '',
            LocationId: 0
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("Please Enter Name").nullable(),
            MobilePhone: Yup.string().required("Please Enter Mobile Number").matches(HelperConstant.UAEPhonenumberPattern.pattern, "Please Enter valid phone number").nullable(),
            Address: Yup.string().required("Please Enter Address").nullable(),
            StateId: Yup.string().notOneOf(['0'], 'Please select a City').required("Please Select a City").nullable(),
            AddressTypeId: Yup.string().notOneOf(['0'], 'Please select a Address').required("Please Select a Address").nullable(),
            LocationId: Yup.string().notOneOf(['0'], 'Please select a Area/District').required("Please Select a Area/District").nullable(),
        }),
        onSubmit(values) {
            CreateCustomerAddress(values);
        },
    })

    const CreateCustomerAddress = (data) => {
        let loc = dofyGeoList.find(x => (x.Id === parseInt(data.LocationId)));
        data.IsDefault = isDefault;
        data.PersonId = personId;
        data.CityId = parseInt(data.LocationId);
        data.PinCode = loc.Name;
        data.CountryId = 1;
        data.LocationPin = loc.Name;
        data.LocationId = parseInt(data.LocationId)

        isEdit ?
            UserAddressServices.edit(data).then(res => {
                if (res.status === 200) {
                    setToast(true);
                    // setChangesInAddress(true);
                    // setDefaultShow(false);
                    window.location.reload();
                }
            }).catch((e: string) => {
                console.log(e);
            })
            :
            UserAddressServices.create(data).then((res) => {
                if (res.status === 200) {
                    setToast(true);
                    // if (URLParamSell) {
                    // dispatch(InputParamChange({ payload: res.data, type: ActionType.ADDRESS_ID }));
                    // setChangesInAddress(true);
                    // setDefaultShow(false);
                    // return dispatch(addressPageChange("timedateslot"));
                    // }
                    window.location.reload();
                }
            }).catch((e: string) => {
                console.log(e);
            });

    }

    const initialSelectedCityHandler = (data: Array<any>, value: string) => {
        if (getUserLanguage() === "in_en") {
            const validLocation = value ? data.filter(it => it.Parent1 === parseInt(value)) : data;
            var uniqueOptions = unique(validLocation, "Name");
            setFilterLocationList(uniqueOptions);
        }
        else {
            const validLocation = value ? data.filter(it => it.Parent === parseInt(value)) : data;
            var uniqueOptions = unique(validLocation, "Name");
            setFilterLocationList(uniqueOptions);
        }
    }

    const selectedCityHandler = (value: any) => {
        var stateIdentifier = stateList?.find(x => x.Id == value)?.Identifier;
        const validLocation = stateIdentifier ? dofyGeoList.filter(it => it.Parent1 === stateIdentifier) : [];
        setFilterLocationList(validLocation); // Set only relevant pincodes
        formik.setFieldValue("LocationId", ""); // Reset selected pincode
    }

    const GetDOFYGeoList = () => {
        CommonService.getWithQueryParam("master", "GetAllDofyGeo", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then((res) => {
            if (res.status === 200) {
                const validLocation =  res.data.filter(it => it.Parent1 === defaultValues.StateId);
                setDofyGeoList(res.data);
                setFilterLocationList(validLocation); 
                //initialSelectedCityHandler(res.data, '');
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const getStatesList = () => {
            CommonService.getWithQueryParam("master", "GetStateList", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then(res => {
                if (res.status === 200) {
                    setStateList(res.data);
                }
            }).catch(e => {
                console.log(e);
            });
        }

    const getCityList = () => {
        CommonService.getWithQueryParam("master", "GetCityList", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setCityList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const getAllAddressType = () => {
        CommonService.getWithQueryParam("master", "GetAllAddressType", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then((res: any) => {
            if (res.status === 200) {
                setAddressType(res.data);
            }
        }).catch((e: string) => {
            console.log(e);
        })
    }
    useEffect(() => {
        if (isEdit) {
            formik.setValues(defaultValues)
        }
        //getCityList();
        getStatesList();
        GetDOFYGeoList();
        getAllAddressType();

   

    }, [])


    return (
        <React.Fragment>
            <Form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Row>
                    <Col xl={6}>
                        <CustomTextBox
                            name="Name"
                            label="Name"
                            id={"Name"}
                            value={formik.values.Name}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Name && formik.errors.Name ? true : false}
                            error={formik.errors.Name}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={true} />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="Address"
                            label="Address"
                            id={"Address"}
                            value={formik.values.Address}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Address && formik.errors.Address ? true : false}
                            error={formik.errors.Address}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={true} />
                    </Col>
                    <Col xl={6}>
                        <CustomNumberOnlyBox
                            name="MobilePhone"
                            label="Mobile Number"
                            id={"MobilePhone"}
                            value={formik.values.MobilePhone}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.MobilePhone && formik.errors.MobilePhone ? true : false}
                            error={formik.errors.MobilePhone}
                            onChange={formik.handleChange}
                            isMandatory={true}
                            min={9}
                            max={10} />
                    </Col>
                    <Col xl={6}>
                        <CustomPhoneNumberBox
                            name="WorkPhone"
                            label="Alternative Mobile Number"
                            id={"WorkPhone"}
                            value={formik.values.WorkPhone}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.WorkPhone && formik.errors.WorkPhone ? true : false}
                            error={formik.errors.WorkPhone}
                            onChange={formik.handleChange}
                            isMandatory={false}
                            min={9}
                            max={10} />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="LandMark"
                            label="Landmark"
                            id={"LandMark"}
                            value={formik.values.LandMark}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.LandMark && formik.errors.LandMark ? true : false}
                            error={formik.errors.LandMark}
                            onChange={formik.handleChange}
                            isMandatory={false} />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="ApartmentNumber"
                            label="Apartment Number/Floor"
                            id={"ApartmentNumber"}
                            value={formik.values.ApartmentNumber}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.ApartmentNumber && formik.errors.ApartmentNumber ? true : false}
                            error={formik.errors.ApartmentNumber}
                            onChange={formik.handleChange}
                            isMandatory={false} />
                    </Col>
                    <Col xl={12}>
                        <Row>
                            <Col xl={4}>
                                <CustomDropdown
                                    id={"AddressTypeId"}
                                    value={formik.values.AddressTypeId}
                                    data={addressType}
                                    displayField="Name"
                                    valueField={"Id"}
                                    name={"AddressTypeId"}
                                    touched={formik.touched.AddressTypeId}
                                    error={formik.errors.AddressTypeId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.AddressTypeId && formik.errors.AddressTypeId ? true : false}
                                    isMandatory={true}
                                    label={'Address Type'}
                                />
                            </Col>
                            <Col xl={4}>
                                <CustomDropdown
                                  name={"StateId"}
                                    id={"StateId"}
                                    value={formik.values.StateId}
                                    data={stateList}
                                    displayField="Name"
                                    valueField={"Id"}
                                    touched={formik.touched.StateId}
                                    error={formik.errors.StateId}
                                    //onChange={formik.handleChange}
                                    onChange={(e) => { formik.handleChange(e); selectedCityHandler(e.target.value); }}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.StateId && formik.errors.StateId ? true : false}
                                    isMandatory={true}
                                    label={'City'}
                                />
                            </Col>
                            <Col xl={4}>
                                <CustomDropdown
                                  name={"LocationId"}
                                    id={"LocationId"}
                                    value={formik.values.LocationId}
                                    data={filterLocation}
                                    displayField="Name"
                                    valueField={"Id"}
                                    touched={formik.touched.LocationId}
                                    error={formik.errors.LocationId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.LocationId && formik.errors.LocationId ? true : false}
                                    isMandatory={true}
                                    label={'Area/District'}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col xl="12" sizeSm="11" md="12" xs="12" lg="12" className="d-flex justify-content-end">
                        <CustomButton type={'reset'} btnClassName={'btn-soft-secondary me-2'} iconClasssName={'bx bx-x font-size-18'} name={undefined} onClick={() => setIsAdd(false)} />
                        <CustomButton type={'submit'} btnClassName={'btn-success'} iconClasssName={''} name={isEdit ? 'Save Changes' : 'Save & Continue'} />
                    </Col>
                </Row>
            </Form>
            {toast && isEdit ? (
                <CustomToaster
                    message={Toaster_ENUM.edit.text}
                    color={"text-success"}
                    toast={toast}
                    setToast={setToast}
                    path={`#`}
                />
            ) : <CustomToaster
                message={Toaster_ENUM.create.text}
                color={"text-success"}
                toast={toast}
                setToast={setToast}
                path={`#`} />}
        </React.Fragment >
    )
}
